import React from 'react';
// import { getMinSec } from '../../../libs/utils';

const Type1Box = (props) => {
  // console.log('===>', props);
  const ds = props.data;
  // console.log('-=--->', ds);
  return (
    <div style={{ ...styles.container }}>
      <div
        style={{
          ...styles.col,
          width: '70%',
          justifyContent: 'flex-start',
          paddingLeft: '2.5rem',
        }}
      >
        {ds && ds.data && ds.data.timeName}
      </div>
      <div
        style={{
          ...styles.col,
          width: '30%',
          justifyContent: 'flex-end',
          paddingRight: '2.5rem',
        }}
      >
        {/* {ds && ds.data && ds.data.time && getMinSec(ds.data.time)} */}
        {ds && ds.data && ds.data.time}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    height: 48,
    flexDirection: 'row',
    justifyContents: 'space-between',
    background: '#FFFFFF',
    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: 10,
    marginTop: 14,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
  },
  col: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 48,
  },
};
export default Type1Box;
